/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Inject, Pipe, PipeTransform} from '@angular/core';
import * as _ from 'lodash';

import {formatAdnStat} from './format-adn-stat';
import {AppLocaleService} from '../locale/app-locale.service';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';

@Pipe({standalone: false, name: 'displayStat'})
export class DisplayStatPipe implements PipeTransform {
  constructor(
    @Inject(LocalNetworkProfile) private readonly LocalNetworkProfile: any,
    private readonly appLocale: AppLocaleService
  ) {
  }

  transform(value: any): string {
    if (_.isNull(value) || _.isUndefined(value) || _.isNaN(value)) {
      return '-';
    }

    const defaultCurrency = this.LocalNetworkProfile.get('defaultCurrency');
    const locale = this.appLocale.getLocaleId();

    if (_.isFinite(value) || _.isArray(value)) {
      return formatAdnStat(value, undefined, undefined, undefined, defaultCurrency, locale);
    }

    if (_.isString(value)) {
      if (!value.trim()) {
        return '-';
      }

      const numericValue = Number(value);
      return Number.isNaN(numericValue)
        ? value
        : formatAdnStat(numericValue, undefined, undefined, undefined, defaultCurrency, locale);
    }

    if (_.isPlainObject(value)) {
      if (_.isEmpty(value)) {
        return '-';
      }

      if (_.has(value, 'currency') && _.isFinite(_.get(value, 'amount'))) {
        return formatAdnStat(value, undefined, undefined, undefined, defaultCurrency, locale);
      }

      if (_.isFinite(_.get(value, 'amount'))) {
        return formatAdnStat(_.get(value, 'amount'), undefined, undefined, undefined, defaultCurrency, locale);
      }

      return '-';
    }

    return value.toString();
  }
}
